import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import { ForgotPasswordFormValues } from '../../auth.model';

export const useValidation = (): yup.SchemaOf<ForgotPasswordFormValues> => {
  const { t } = useTranslation();
  return yup.object().shape({
    email: yup
      .string()
      .email(t('AUTH.FORGOT_PASSWORD.INPUT_EMAIL_VALIDATION_INVALID'))
      .required(t('AUTH.FORGOT_PASSWORD.INPUT_EMAIL_VALIDATION_REQUIRED')),
  });
};
